<template>
  <a-card :bordered="false">
    <a-form-model
      :model="ruleForm"
      ref="ruleForm"
      :rules="tabRule"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <div class="title">酒店类权益</div>
      <a-row :gutter="20">
        <a-col :span="8">
          <a-form-model-item label="折扣" prop="hotelDiscount">
            <a-input-number
              class='input-number'
              v-model="ruleForm.hotelDiscount"
              :min="10"
              :max="100"
              :precision="0"
              placeholder="请输入"
              @change="(e) => inputNumberChange(e,'hotelDiscount')"
            />
            % <span v-if="ruleForm.hotelDiscount">({{ formatDiscount(ruleForm.hotelDiscount) }}折)</span>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item label="房型升级" prop="hotelOptionNum">
            <a-input-number
              class='input-number'
              v-model="ruleForm.hotelOptionNum"
              :min="0"
              :max="99999999"
              :precision="0"
              placeholder="请输入"
              @change="(e) => inputNumberChange(e,'hotelOptionNum')"
            />
            次
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="20">
        <a-col :span="8">
          <a-form-model-item label="免费早餐" prop="hotelBreakfastNum">
            <a-input-number
              class='input-number'
              v-model="ruleForm.hotelBreakfastNum"
              :min="0"
              :max="99999999"
              :precision="0"
              placeholder="请输入"
              @change="(e) => inputNumberChange(e,'hotelBreakfastNum')"
            />
            次
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item label="延迟退房" prop="hotelReturnNum">
            <a-input-number
              class='input-number'
              v-model="ruleForm.hotelReturnNum"
              :min="0"
              :max="99999999"
              :precision="0"
              placeholder="请输入"
              @change="(e) => inputNumberChange(e,'hotelReturnNum')"
            />
            次
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="20">
        <a-col :span="8">
          <a-form-model-item label="免费取消" prop="hotelCancelNum">
            <a-input-number
              class='input-number'
              v-model="ruleForm.hotelCancelNum"
              :min="0"
              :max="99999999"
              :precision="0"
              placeholder="请输入"
              @change="(e) => inputNumberChange(e,'hotelCancelNum')"
            />
            次
          </a-form-model-item>
        </a-col>
      </a-row>
      <div class="title">跟团类权益</div>
      <a-form-model-item label="折扣" prop="groupDiscount" :label-col="labelColOne" :wrapper-col="wrapperColOne">
        <a-input-number
          class='input-number'
          v-model="ruleForm.groupDiscount"
          :min="10"
          :max="100"
          :precision="0"
          placeholder="请输入"
          @change="(e) => inputNumberChange(e,'groupDiscount')"
        />
        % <span v-if="ruleForm.groupDiscount">({{ formatDiscount(ruleForm.groupDiscount) }}折)</span>
        <a-radio-group style="margin-left: 50px" v-model="ruleForm.groupDiscountType" @change="selectType">
          <a-radio :value="0">应用至全部跟团产品</a-radio>
          <a-radio :value="1">指定分组享受折扣</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item v-if="ruleForm.groupDiscountType === 1" label="选择分组" prop="employeeInterestsGroupList"
                         :label-col="labelColOne" :wrapper-col="wrapperColOne">
        <a-button type="primary" @click="selectProductGroup">选择</a-button>
        <span style="margin-left: 20px">
          <template v-for="tagItem in ruleForm.employeeInterestsGroupList">
            <a-tag closable color="blue" @close="handleProductGroupClose(tagItem.groupId)" :key="tagItem.groupId">
              {{ tagItem.groupName }}
            </a-tag>
          </template>
        </span>
      </a-form-model-item>
    </a-form-model>
    <a-button
      style="margin-left: 240px"
      htmlType="submit"
      type="primary"
      @click="submitEvent"
      :loading="submitLoading"
    >保存
    </a-button>

    <selected-product-dialog
      title="选择商品分组"
      ref="groupDialog"
      :col="2"
      :show="showSelectedGroupDialog"
      :itemNames="['search_proName']"
      :query-params="selectedQueryGroupParams"
      :request-promise="getGroupRequest"
      @close="showSelectedGroupDialog=false"
      :columns="getGroupColumns()"
    >
      <a-form-item
        label="商品分组名称"
        slot="search_proName"
        :wrapperCol="{span:18}"
        :labelCol="{span:6}"
      >
        <a-input
          v-model="selectedQueryGroupParams.groupName"
          style="width: 100%"
          placeholder="请输入商品分组名称"
        />
      </a-form-item>
      <template slot="action" slot-scope="rowItem">
        <a-button v-if="ruleForm.employeeInterestsGroupList.some(item => item.groupId === rowItem.record.groupId)">
          已选择
        </a-button>
        <a-button v-else type="primary" @click="onSelectedGroupResult(rowItem.record)">选择</a-button>
      </template>
    </selected-product-dialog>
  </a-card>
</template>

<script>
import WelfareMallMixins from '@/views/service/serviceProvider/welfareMall/mixins/WelfareMallMixins'
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'

export default {
  name: 'WelfareMallStaffRights',
  mixins: [WelfareMallMixins],
  components: {
    SelectedProductDialog
  },
  data() {
    return {
      ruleForm: {
        groupDiscountType: 0,
        employeeInterestsGroupList: [],
        groupIds: []
      },
      tabRule: {
        hotelDiscount: [
          { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ],
        hotelOptionNum: [
          { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ],
        hotelBreakfastNum: [
          { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ],
        hotelReturnNum: [
          { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ],
        hotelCancelNum: [
          { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ],
        groupDiscount: [
          { required: true, message: '请输入', trigger: ['blur', 'change'] }
        ],
        employeeInterestsGroupList: [
          { required: true, message: '请选择', trigger: ['blur', 'change'] }
        ]
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      labelColOne: { span: 2 },
      wrapperColOne: { span: 22 },
      submitLoading: false,
      showSelectedGroupDialog: false,
      selectedQueryGroupParams: { groupStatus: 1 },
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId
    }
  },
  created() {
    this.getDetail()
  },
  methods: {
    formatDiscount(discount) {
      return discount % 10 === 0 ? discount / 10 : discount
    },
    getDetail() {
      this.getHttpServices().getServerApiService().post('employeeInterests/queryDetail', {
        merchantId: this.merchantId,
        platformId: this.platformId
      }).then(res => {
        if (res) {
          res.groupDiscountType = res.groupDiscountType || 0
          res.employeeInterestsGroupList = res.employeeInterestsGroupList || []
          res.groupIds = res.groupIds || []
          this.ruleForm = res
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    inputNumberChange(e, type) {
      this.$nextTick(() => {
        this.$refs.ruleForm.validateField(type)
      })
    },
    selectProductGroup() {
      this.showSelectedGroupDialog = true
    },
    getGroupRequest(params) {
      return this.getHttpServices().getProService().post('/proGroup/findProGroupList', params)
    },
    getGroupColumns() {
      return [
        {
          title: 'id',
          dataIndex: 'groupId',
          width: '60px'
        },
        {
          title: '分组名称',
          dataIndex: 'groupName'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: '200px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    onSelectedGroupResult(obj) {
      // 检查是否已经存在相同的 groupId
      const isExist = this.ruleForm.employeeInterestsGroupList.some(
        item => item.groupId === obj.groupId
      )
      if (isExist) {
        this.$message.error('请勿重复添加商品分组')
        return
      }
      // 添加新的分组
      this.ruleForm.employeeInterestsGroupList.push({
        groupId: obj.groupId,
        groupName: obj.groupName
      })
      this.ruleForm.groupIds.push(obj.groupId)
      this.showSelectedGroupDialog = false
    },
    handleProductGroupClose(removedTag) {
      if (this.ruleForm.employeeInterestsGroupList.length > 0) {
        this.ruleForm.employeeInterestsGroupList = this.ruleForm.employeeInterestsGroupList.filter(tag => tag.groupId !== removedTag)
        this.ruleForm.groupIds = this.ruleForm.groupIds.filter(tag => tag !== removedTag)
      }
    },
    selectType() {
      this.$set(this.ruleForm, 'employeeInterestsGroupList', [])
      this.$set(this.ruleForm, 'groupIds', [])
    },
    submitEvent() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.updateRequest()
        } else {
          this.$message.error('请完善必要的信息')
        }
      })
    },
    updateRequest() {
      if (this.ruleForm.groupDiscountType === 1 && !this.ruleForm.employeeInterestsGroupList.length) return this.$message.error('请选择商品分组')
      if (!this.submitLoading) {
        this.submitLoading = true
        let params = {
          ...this.ruleForm,
          merchantId: this.merchantId,
          platformId: this.platformId,
          employeeInterestsGroupList: undefined
        }
        const url = params.id ? 'employeeInterests/update' : 'employeeInterests/add'
        this.getHttpServices().getServerApiService().post(url, params).then(res => {
          this.$message.success('保存成功')
          this.getDetailInfo()
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.title {
  padding-left: 10px;
  border-left: 1px solid cornflowerblue;
  margin: 10px 0;
}

.mb0 {
  margin-bottom: 0;
}

.input-number {
  width: 100px;
}
</style>
